import React from 'react';
import './AudioMessage.scss';
import Box from '@mui/material/Box';
const VideoMessage = ({ fileUrl }) => {
  return (
    <Box
      sx={{
        maxWidth: 600,
        borderRadius: 2,
        overflow: 'hidden',
        margin: '9px 8px 9px 22px',
      }}
    >
      <video controls width="100%" style={{ display: 'block' }}>
        <source src={fileUrl} />
        Your browser does not support the video tag.
      </video>
    </Box>
  );
};
export default VideoMessage;
